<template>
  <div>
    <h1>Lista de Usuários</h1>
    <div v-if="cliente.id">
      <b-card>
        <div class="d-flex mb-2">
          <div class="w-75 mr-auto">
            <b-input-group size="sm">
              <b-form-input
                v-model="termo_pesquisa"
                placeholder="Pesquisar"
              ></b-form-input>
              <b-input-group-append>
                <b-button @click="loadData" variant="exitos">Buscar</b-button>
              </b-input-group-append>
            </b-input-group>
          </div>
          <div>
            <b-button @click="goToNewUsersPage" size="sm" variant="exitos">
              Adicionar novo usuário
            </b-button>
          </div>
        </div>

        <b-table
          striped
          hover
          :items="cliente_users"
          :fields="fields"
          show-empty
        >
          <template #cell(roles)="{ item }">
            <p class="mb-0">
              <b-badge
                v-for="(role, key) in item.roles"
                :key="key"
                class="bg-exitos mr-1 text-capitalize font-weight-600 text-white"
                v-text="role.name"
              />
            </p>
          </template>
          <template #cell(ativo)="{ item }">
            <font-awesome-icon
              :icon="getIconUser(item)"
              :class="getClassUser(item)"
            />
          </template>
          <template #cell(actions)="row">
            <div
              class="table-actions d-flex justify-content-end cursor-pointer mr-2"
            >
              <b-button
                variant="outline-exitos"
                @click="
                  $router.push({
                    name: 'users_edit',
                    params: { id: row.item.id },
                  })
                "
              >
                <font-awesome-icon icon="far fa-edit" />
              </b-button>
            </div>
            <!-- Comentado pois função será implementada posteriormente -->
            <!-- <Actions :item="row.item" :view_show="false" :view_edit="$can('user:edit')"
              :view_delete="$can('user:delete')" edit_to="users_edit" @delete="delete_user" /> -->
          </template>

          <template #empty="{}">
            <h5 class="text-center">Nenhum item encontado</h5>
          </template>
        </b-table>
      </b-card>

      <div class="mt-4">
        <pagination-nav
          v-model="pagination_users.current_page"
          :pagination="pagination_users"
          @input="loadData()"
        />
      </div>
    </div>
    <div v-else>
      <base-alert type="info" class="m-4 p-4 text-center">
        <span class="alert-inner--icon mr-2">
          <font-awesome-icon icon="fas fa-exclamation-triangle" />
        </span>
        <span class="alert-inner--text">
          <strong>Atenção!</strong><br />
          Para visualizar os Usuários do Cliente é necessário, primeiro, salvar
          as informações!
        </span>
      </base-alert>
    </div>
  </div>
</template>

<script>
import Actions from "@/components/Table/Actions.vue";
import { mapState, mapActions } from "vuex";

export default {
  components: { Actions },
  data: () => ({
    termo_pesquisa: "",
    per_page: 15,
    sortBy: "ativo",
    sortDesc: true,
  }),
  computed: {
    ...mapState("clientes", ["cliente", "cliente_users", "pagination_users"]),
    fields() {
      return [
        { key: "id", label: "COD", class: "col-1" },
        { key: "name", label: "Nome" },
        { key: "email", label: "Email" },
        { key: "ativo", label: "Ativo", class: "text-center" },
        { key: "roles", label: "Papeis" },
        { key: "actions", label: "", class: "cell-actions" },
      ];
    },
  },
  methods: {
    preventFormSubmit(e) {
      console.log(e);
      e.preventDefault();
    },
    ...mapActions("clientes", ["ActionSetClienteUsers"]),
    goToNewUsersPage() {
      this.$router.push({
        name: "users_create",
        path: `/users/novo`,
        params: { cliente_id: this.cliente.id + "" },
      });
    },
    getIconUser(item) {
      return item.ativo ? "check-circle" : "times-circle";
    },
    getClassUser(item) {
      return !!item.ativo ? "text-success" : "text-danger";
    },
    async loadData() {
      try {
        const id = this.cliente.id;

        let payload = {
          id: id,
          page: this.pagination_users.current_page,
          per_page: this.pagination_users.per_page,
          orderBy: this.sortBy,
          sortBy: this.sortDesc ? "desc" : "asc",
          q: this.termo_pesquisa,
        };

        await this.ActionSetClienteUsers(payload);
      } catch (error) {
        this.$notifications.addNotification({
          message: "Erro ao carregar dados da listagem",
          icon: "exclamation-triangle",
          type: "danger",
        });
      }
    },
  },
  watch: {
    "cliente.id": {
      deep: true,
      handler: function (id) {
        if (id) {
          this.loadData();
        }
      },
    },
  },
  async created() {
    this.per_page = this.pagination_users.per_page;
    if (this.cliente.id) {
      this.loadData();
    }
  },
};
</script>
